module.exports = __webpack_public_path__ + "static/media/image3.07a130e3.png";